module.exports = __webpack_public_path__ + "static/media/BG_Home.f0c32a39.png";